// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b0cf5a35a64e91b1c1f0","655":"12c26a3d56cbd76c4c2e"}[chunkId] + ".js";
};